import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PatientFlagDataModel} from '../models/patient/patient-flag-data.model';
import {AppointmentFlagDataModel} from '../models/appointments/appointment-flag-data.model';

@Injectable({
  providedIn: 'root'
})
export class FlagsService {

  constructor(private http: HttpClient) {
    //
  }

  runFlagRoutineForPatient(patientId: string, locid: string) {
    return this.http.get<PatientFlagDataModel[]>(`api/flags/check-patient-flags/${locid}/${patientId}`);
  }

  runFlagRoutineForAppointment(appointmentId: string) {
    return this.http.get<AppointmentFlagDataModel[]>(`api/flags/check-appointment-flags/${appointmentId}`);
  }

  getPatientFlags(LOCID: string, patientId: string) {
    return this.http.get<PatientFlagDataModel[]>(`api/flags/get-patient-flags/${LOCID}/${patientId}`);
  }
}
